export function concat_ws(args: readonly (string | null | undefined)[],
                          separator: string = ' '): string {
  if (args.length === 0)
    return '';
  args = args.filter(x => x !== null && x !== undefined);
  if (args.length === 0)
    return '';
  return args.join(separator);
}
